export default {
    // /////////////////////////////////////////////
    // Notifications
    // /////////////////////////////////////////////	

    UPDATE_NOTIFICATIONS(state, val) {
        state.Notifications = val
    },
}